import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, consultaUnidadeTransito } from './types';

export const INITIAL_STATE: consultaUnidadeTransito = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): consultaUnidadeTransito {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_UNIDADE_TRANSITO_REQUEST: {
				break;
			}

			case Types.CONSULTA_UNIDADE_TRANSITO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTA_UNIDADE_TRANSITO_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTA_UNIDADE_TRANSITO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
